export default __webpack_public_path__ + "static/media/QR.8d4e4917.jpg";